import React from "react";
import { truncate } from "lodash";
import moment from "moment";
import "./import-installed-function.scss";
import {GCPENDPOINT} from "../../../../constant/common";
import Placeholder_Icon from "../../../../assets/svg/Placeholder_Icon.svg";

interface IImportInstalledWidget {
  setVisible: any;
  functions: any;
  activeTab: any;
  setSelectedFunc: any;
}

const getFormatDescription = (value: string, length: number) =>
  truncate(value, { length, separator: " " });

export const ImportInstalledFunction: React.FC<IImportInstalledWidget> = ({ functions, activeTab, setVisible, setSelectedFunc }) => {
  const handleImportFunction = async (functionData: any) => {
    setVisible({ visible: true, type: "Import" });
    setSelectedFunc(functionData);
  };

  return (
    <div>
      <div className="function-import-card">
        {functions.map((Func: any) => (
          <div
            key={Func.id}
            className="import-card"
          >
            <div style={{display:"flex", alignItems:"center"}}>
              <div className="image-container" >
                <img 
                  src={Func.preview_image ? `${Func.preview_image?.startsWith("https://") ? Func.preview_image : GCPENDPOINT+Func.preview_image}` : Placeholder_Icon}
                  alt="func-icon"  
                />
              </div>
              <div className="icon-info">
                <div className="info">
                  <h4 className="hl">{Func.name}</h4>
                  <p>{getFormatDescription(Func.description, 77)}</p>
                </div>
              </div>
            </div>

            <div className="author-install">
              <div className="author">
                <div className="author-name">
                  By:{" "}
                  <span className="hl">
                    {Func.created_by.first_name} {Func.created_by.last_name}
                  </span>
                </div>
                <div className="author-date">
                  updated on:{" "}
                  <span className="hl">{moment(Func.created_at).format("MMM DD, YYYY")}</span>
                </div>
              </div>
              <div className="install">
                {activeTab === "Installed Functions" &&
                  <button
                    data-test-id="import"
                    onClick={() => handleImportFunction(Func)}
                    className={`${Func.is_installed ? "btn-installed" : "btn-install"}`}
                  >
                    Import
                  </button>
                }
                <div className="version-updated">
                  <p>
                    Version: <span className="hl">{Func.version_tag}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
